import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    faceId: String
  }

  delete(event) {
    if (confirm("Are you sure you want to delete this face?")) {
      // Find and click the actual delete button outside the form
      const deleteButton = document.querySelector(`#delete_face_${this.faceIdValue}`)
      if (deleteButton) {
        deleteButton.click()
      }
    }
  }
} 